var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container",style:([
    _vm.isDesktop
      ? { 'background-image': 'url(' + _vm.backgroundFull + ')' }
      : { 'background-image': 'url(' + _vm.backgroundMobile + ')' } ])},[_c('Header'),_c('Detail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }